module.exports = __webpack_public_path__ + "static/img/product-center.753483b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/product-center.jpg
// module id = w4QX
// module chunks = 5